//#region Imports
import { AuthenticationService } from '@app/member-response-portal/service/authentication.service';
import { Component, Inject, OnInit } from '@angular/core';
import { DialogService } from '@app/core/services/dialog-service.service';
import { Helper } from '@rawlings/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PHONE_NUMBER } from '@app/member-response-portal/model/constants';
import { SurveyStatusEnum } from '@app/member-response-portal/model/surveyStatus';
//#endregion Imports
@Component({
    selector: 'app-failed-request-dialog',
    templateUrl: './failed-request-dialog.component.html',
    styleUrls: ['./failed-request-dialog.component.scss']
})
export class FailedRequestDialogComponent implements OnInit{
    //#region Public Variables
    public Message: string = null;
    public Title: string = null;
    public PhoneNumber: string;
    //#endregion Public Variables

    //#region Protected Variables
    //#endregion Protected Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    constructor(
        private authenticationService: AuthenticationService,
        private dialogService: DialogService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    public ngOnInit(): void {
        const cachePolicy: string = localStorage.getItem(PHONE_NUMBER);

        if (!Helper.IsEmpty(cachePolicy)){
            this.PhoneNumber = cachePolicy;
        }

        const defaultTitle: string = 'An error in saving the form has occurred';
        const defaultMessage: string = `Please contact ${this.PhoneNumber} for assistance with filling out the form.`;

        this.data = this.data || {};
        this.Title = defaultTitle;
        this.Message = defaultMessage;

        const invalidStatuses: any = [
            SurveyStatusEnum.New,
            SurveyStatusEnum.LetterGeneration,
            SurveyStatusEnum.Error
        ];

        if (this.data.IsSurveySubmitted) {
            this.Title = this.data.Message;
            this.Message = `If you have any additional questions regarding this questionnaire or if the information has changed, please contact the Rawlings Company at: ${this.PhoneNumber}.`;
        } else if (invalidStatuses.includes(this.data.SurveyStatus)) {
            this.Title = this.data.Message;
            this.Message = `Please contact the Rawlings Company at: ${this.PhoneNumber}.`;
        } else if (this.data.SurveyStatus === SurveyStatusEnum.None) {
            this.Title = 'Invalid Information';
            this.Message = this.data.Message;
        }
    }

    //#endregion Constructor

    //#region Public Methods
    public OnClickRedirectToLogin(): void {
        this.authenticationService.LogoutAndRedirectToLogin();
        this.dialogService.CloseDialog();
    }
    //#endregion Public Methods
}
